import { 
  Navigate,
  useLocation
} from 'react-router-dom'

import useFirebase from 'hooks/firebase'
import LoadingPage from 'pages/loading'

// https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f

const ProtectedRoute = ({ children, role }) => {
  const { auth } = useFirebase()

  const credentials = auth.credentials
  const user = auth.user

  const location = useLocation()

  const paths = {
    'admin': '/admin',
    'director': '/director'
  }

  if (credentials) {
    if (!user) {
      return <LoadingPage />
    }

    // if (!credentials.emailVerified) {
    //   return <Navigate to={'/verify'} state={{ from: location.pathname }} replace />
    // }

    return user.role === role ? children : <Navigate to={paths[user.role]} state={{ from: location.pathname }} replace />
  } else {
    return (
      <Navigate to='/login' state={{ from: location.pathname }} replace />
    )
  }
}

export default ProtectedRoute